<template>
  <v-card class="open-level">
    <v-subheader>
      <v-icon medium color="success" class="mr-2">trending_up</v-icon>
      {{date}} <span class="ml-2 body-2">Открыт уровень {{openedLevel}}</span>
    </v-subheader>
  </v-card>
</template>

<script>
  export default {
    name: "OpenLevel",
    props: ["date", "description", "openedLevel"]
  }
</script>

<style scoped>
  .open-level {
    border: 1px solid #78909C;
  }
</style>